import { render, staticRenderFns } from "./nickName.vue?vue&type=template&id=3ef729ef&scoped=true"
import script from "./nickName.vue?vue&type=script&lang=js"
export * from "./nickName.vue?vue&type=script&lang=js"
import style0 from "./nickName.vue?vue&type=style&index=0&id=3ef729ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef729ef",
  null
  
)

export default component.exports